// A small floating progress panel for file uploads, drawn straight into the page (no React tree
// involved) so EVERY upload in the dashboard gets a progress bar without each page having to wire one up.
// Pages that already draw their own bar (course builder, gallery) pass their own onProgress and skip this.

let panel = null;
let seq = 0;

function ensurePanel() {
  if (panel && document.body.contains(panel)) return panel;
  panel = document.createElement("div");
  panel.setAttribute("dir", "rtl");
  panel.style.cssText =
    "position:fixed;bottom:16px;left:16px;z-index:100000;display:flex;flex-direction:column;gap:8px;" +
    "max-width:340px;width:calc(100vw - 32px);font-family:inherit;";
  document.body.appendChild(panel);
  return panel;
}

export function startUpload(fileName) {
  const id = ++seq;
  const row = document.createElement("div");
  row.dataset.uploadId = String(id);
  row.style.cssText =
    "background:#fff;border:1px solid #d9d9d9;border-radius:8px;padding:10px 12px;box-shadow:0 4px 14px rgba(0,0,0,.15);";

  const title = document.createElement("div");
  title.style.cssText = "display:flex;justify-content:space-between;gap:10px;font-size:13px;margin-bottom:6px;";
  const label = document.createElement("span");
  label.style.cssText = "overflow:hidden;text-overflow:ellipsis;white-space:nowrap;";
  label.textContent = "جاري رفع: " + (fileName || "ملف");
  const percent = document.createElement("strong");
  percent.textContent = "0%";
  title.appendChild(label);
  title.appendChild(percent);

  const track = document.createElement("div");
  track.style.cssText = "height:8px;background:#eee;border-radius:4px;overflow:hidden;";
  const bar = document.createElement("div");
  bar.style.cssText = "height:100%;width:0%;background:#2196f3;transition:width .15s ease;";
  track.appendChild(bar);

  row.appendChild(title);
  row.appendChild(track);
  ensurePanel().appendChild(row);

  const remove = (delay) => setTimeout(() => {
    if (row.parentNode) row.parentNode.removeChild(row);
    if (panel && panel.childNodes.length === 0 && panel.parentNode) {
      panel.parentNode.removeChild(panel);
      panel = null;
    }
  }, delay);

  return {
    update(pct) {
      const v = Math.max(0, Math.min(100, Math.round(pct)));
      bar.style.width = v + "%";
      percent.textContent = v + "%";
    },
    finish(ok) {
      if (ok) {
        bar.style.width = "100%";
        bar.style.background = "#4caf50";
        percent.textContent = "تم ✓";
        remove(1200);
      } else {
        bar.style.background = "#f44336";
        percent.textContent = "فشل";
        remove(4000);
      }
    },
  };
}
